import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatInputModule, MatCheckboxModule, MatDatepickerModule,  MatButtonModule, MatSelectModule, MatIconModule, MatToolbarModule, MatProgressSpinnerModule, MatCardModule, MatNativeDateModule} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatVideoModule } from 'mat-video';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// Import your library
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NgxPaginationModule } from 'ngx-pagination';
import { DialogsComponent } from './dialogs/dialogs.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PopupComponent } from './dialogs/popup/popup.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HotelDialogComponent } from './common/hotel-dialog/hotel-dialog.component';
import { EventEmitterService } from './event-emitter.service';
import { TokenInterceptorService } from './token-interceptor.service';
import { AuthGuardService } from './guards/auth-guard.service';
import { EditReservationComponent } from './manage-bookings/edit-reservation/edit-reservation.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ProfileImageComponent } from './common/profile-image/profile-image.component';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { AgmCoreModule } from '@agm/core';
import { constVariables } from "./constants/ConstantPath";
import {GalleryModule} from '@ks89/angular-modal-gallery';
import { MaterialModule } from './material/material.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { HotelSearchComponent } from './hotel-search/hotel-search.component';

@NgModule({
  declarations: [
    AppComponent,
    DialogsComponent,
    PopupComponent,
    HotelDialogComponent,
    EditReservationComponent,
    ProfileImageComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    HotelSearchComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    MatInputModule,
    MatButtonModule,
    NgxDaterangepickerMd.forRoot(),
    ReactiveFormsModule,
    MatSelectModule,
    MatIconModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxPaginationModule,
    AngularMaterialModule,
    MatVideoModule,
    NgbModule,
    BrowserAnimationsModule,
    SlickCarouselModule,
    ImageCropperModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    AgmCoreModule.forRoot({
      apiKey: constVariables.googleApiKey,
      libraries: ['places']
    }),
    MatGoogleMapsAutocompleteModule,
    GalleryModule.forRoot(),
    MaterialModule
  ],
  providers: [
    EventEmitterService,
    AuthGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [DialogsComponent,PopupComponent,HotelDialogComponent,ProfileImageComponent]
})
export class AppModule { }
